import * as React from 'react'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'
import MonitoringSelector, {
  ValueProps as MonitoringSelectorValueProps,
  EventProps as MonitoringSelectorEventProps,
} from '@mulesoft/monitoring-center-components/lib/components/Selector/MonitoringSelector/MonitoringSelector'
import Button from '@mulesoft/anypoint-components/lib/Button'
import './LogPointsSelector.css'

export type ValueProps = MonitoringSelectorValueProps

export type EventProps = MonitoringSelectorEventProps & {
  onView: (environmentId: string, resourceId: string, versionId?: string) => void
}

export type Props = ValueProps & EventProps

export type State = {
  environmentIdSelected?: string
  resourceIdSelected?: string
  versionIdSelected?: string
}

export class LogPointsSelector extends React.Component<Props, State> {

  private static BASE_CONTAINER_CLASS_NAME = 'log-points-selector-container'

  constructor(props: Props) {
    super(props)

    const {environmentSelector, resourceSelector, versionSelector} = this.props
    this.state = {
      environmentIdSelected: environmentSelector.selected && environmentSelector.selected.id.toString(),
      resourceIdSelected: resourceSelector.selected && resourceSelector.selected.id.toString(),
      versionIdSelected: versionSelector.selected && versionSelector.selected.id.toString()
    }

    this.environmentSelected = this.environmentSelected.bind(this)
    this.resourceSelected = this.resourceSelected.bind(this)
    this.versionSelected = this.versionSelected.bind(this)
    this.onView = this.onView.bind(this)
    this.isReadyToSelect = this.isReadyToSelect.bind(this)
  }

  environmentSelected(environmentId: string) {
    this.setState({environmentIdSelected: environmentId})
    this.props.environmentSelected(environmentId)
  }

  resourceSelected(resourceId: string, resourceType: ResourceType) {
    this.setState({resourceIdSelected: resourceId})
    this.props.resourceSelected(resourceId, resourceType)
  }

  versionSelected(versionId: string) {
    this.setState({versionIdSelected: versionId})
    this.props.versionSelected(versionId)
  }

  onView() {
    const {environmentIdSelected, resourceIdSelected, versionIdSelected} = this.state
    if (environmentIdSelected && resourceIdSelected) {
      this.props.onView(environmentIdSelected, resourceIdSelected, versionIdSelected)
    }
  }

  isReadyToSelect() {
    const {environmentSelector, resourceSelector, versionSelector} = this.props
    const environmentSelected = environmentSelector.selected !== undefined
    const resourceSelected = resourceSelector.selected
    const versionSelected = versionSelector.selected !== undefined
    const isResourceLoading =
      !resourceSelected || (resourceSelected.resourceType === ResourceType.API && (!versionSelected || !versionSelector.versions))

    return environmentSelected && !isResourceLoading
  }

  getMonitoringSelectorProps() {
    return {
      environmentSelector: this.props.environmentSelector,
      resourceSelector: this.props.resourceSelector,
      versionSelector: this.props.versionSelector,
      environmentSelected: this.environmentSelected,
      resourceSelected: this.resourceSelected,
      versionSelected: this.versionSelected
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, prevContext: any): void {
    const {environmentSelector, resourceSelector, versionSelector} = this.props
    const version = versionSelector.selected

    if (prevProps.environmentSelector.selected !== environmentSelector.selected && environmentSelector.selected) {
      this.setState({...this.state, environmentIdSelected: environmentSelector.selected.id})
    }
    if (prevProps.resourceSelector.selected !== resourceSelector.selected && resourceSelector.selected) {
      this.setState({...this.state, resourceIdSelected: resourceSelector.selected.id, versionIdSelected: undefined})
    }
    if (prevProps.versionSelector.selected !== version) {
      this.setState({...this.state, versionIdSelected: version ? version.id.toString() : undefined})
    }
  }

  render() {
    const monitoringSelectorProps = this.getMonitoringSelectorProps()
    const baseClassName = LogPointsSelector.BASE_CONTAINER_CLASS_NAME
    const className = this.props.className ? `${baseClassName} ${this.props.className}` : baseClassName

    return (
      <div className={className}>
        <MonitoringSelector {...monitoringSelectorProps} />
        <Button kind="primary" onClick={this.onView} disabled={!this.isReadyToSelect()} testId={'log-points-select-button'}>Select</Button>
      </div>
    )
  }
}
